import React from 'react'
import PropTypes from 'prop-types'
import ContentHeader from './components/ContentHeader'
import ContentBody from './components/ContentBody'
import ProductFlatListModal from '../ProductFlatListModal'

const WfsDisclaimer = ({ seller, isOpen, setIsOpen }) => {
  const getContent = () => {
    const content = {
      header: undefined,
      body: undefined,
    }

    content.header = <ContentHeader />
    content.body = <ContentBody seller={seller} />

    return content
  }

  const { header, body } = getContent()

  const props = {
    body,
    error: true,
    isOpen: isOpen,
    onClose: () => setIsOpen(false),
    size: 'small',
    title: header,
    allowBackdrop: false,
    customClass: 'wfs-disclaimer-modal',
  }

  return <ProductFlatListModal {...props} />
}

WfsDisclaimer.propTypes = {
  seller: PropTypes.string,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
}

WfsDisclaimer.defaultProps = {
  seller: '',
  isOpen: false,
  setIsOpen: () => {},
}

export default React.memo(WfsDisclaimer)
